import { useQuery } from "react-query";

import { getData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { USE_MOCK } from "../util";
import { IPaginatedResponse } from "../../../../interfaces/response";

// Mock data
export const mockTermsAndConditions: TermsAndConditions[] = [
  {
    id: 1,
    title: "General Terms of Service",
    termsAndConditions: `
      <div class="terms-content">
        <h1>Terms of Service</h1>
        
        <h2>1. Acceptance of Terms</h2>
        <p>By accessing and using this service, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
        
        <h2>2. Use License</h2>
        <p>Permission is granted to temporarily download one copy of the materials on our website for <strong>personal, non-commercial transitory viewing only</strong>. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
        <ul>
          <li>modify or copy the materials</li>
          <li>use the materials for any commercial purpose or for any public display (commercial or non-commercial)</li>
          <li>attempt to decompile or reverse engineer any software contained on our website</li>
          <li>remove any copyright or other proprietary notations from the materials</li>
        </ul>
        
        <h2>3. Disclaimer</h2>
        <p>The materials on our website are provided on an <em>'as is'</em> basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including without limitation:</p>
        <ol>
          <li>Implied warranties or conditions of merchantability</li>
          <li>Fitness for a particular purpose</li>
          <li>Non-infringement of intellectual property or other violation of rights</li>
        </ol>
        
        <h2>4. Limitations</h2>
        <p>In no event shall our company or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we or our authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
        
        <blockquote>
          <p><strong>Important:</strong> These terms are subject to change at any time. Continued use of the service constitutes acceptance of any changes.</p>
        </blockquote>
      </div>
    `,
  },
  {
    id: 2,
    title: "Privacy Policy",
    termsAndConditions: `
      <div class="privacy-policy">
        <h1>Privacy Policy</h1>
        <p><em>Last updated: January 15, 2024</em></p>
        
        <h2>Information We Collect</h2>
        <p>We collect information you provide directly to us, such as when you:</p>
        <ul>
          <li>Create or modify your account</li>
          <li>Request customer support or contact us</li>
          <li>Participate in surveys or promotions</li>
          <li>Make purchases or transactions</li>
        </ul>
        
        <h2>How We Use Your Information</h2>
        <p>We use the information we collect to <strong>provide, maintain, and improve our services</strong>. This includes:</p>
        <div style="background-color: #f8f9fa; padding: 15px; border-left: 4px solid #007bff; margin: 10px 0;">
          <h3>Core Services</h3>
          <ul>
            <li>Processing transactions and sending related information</li>
            <li>Providing customer support and responding to inquiries</li>
            <li>Monitoring and analyzing trends and usage</li>
            <li>Personalizing and improving user experience</li>
          </ul>
        </div>
        
        <h2>Information Sharing and Disclosure</h2>
        <p>We <span style="color: #dc3545; font-weight: bold;">do not sell, trade, or otherwise transfer</span> your personally identifiable information to third parties without your consent, except as described in this policy.</p>
        
        <h3>We may share information in the following circumstances:</h3>
        <table border="1" style="border-collapse: collapse; width: 100%; margin: 10px 0;">
          <thead>
            <tr style="background-color: #e9ecef;">
              <th style="padding: 8px; text-align: left;">Circumstance</th>
              <th style="padding: 8px; text-align: left;">Information Shared</th>
              <th style="padding: 8px; text-align: left;">Purpose</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="padding: 8px;">Service Providers</td>
              <td style="padding: 8px;">Limited personal data</td>
              <td style="padding: 8px;">To perform services on our behalf</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Legal Requirements</td>
              <td style="padding: 8px;">Required information only</td>
              <td style="padding: 8px;">To comply with legal obligations</td>
            </tr>
            <tr>
              <td style="padding: 8px;">Business Transfers</td>
              <td style="padding: 8px;">All collected data</td>
              <td style="padding: 8px;">In connection with merger or acquisition</td>
            </tr>
          </tbody>
        </table>
        
        <h2>Data Security</h2>
        <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.</p>
        
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ol>
          <li><strong>Access</strong> your personal information</li>
          <li><strong>Correct</strong> inaccurate information</li>
          <li><strong>Delete</strong> your personal information</li>
          <li><strong>Object</strong> to processing of your information</li>
          <li><strong>Data portability</strong> in certain circumstances</li>
        </ol>
        
        <p>To exercise these rights, please contact us at <a href="mailto:privacy@example.com">privacy@example.com</a></p>
      </div>
    `,
  },
  {
    id: 3,
    title: "Cookie Policy",
    termsAndConditions: `
      <div class="cookie-policy">
        <h1>Cookie Policy</h1>
        
        <h2>What Are Cookies?</h2>
        <p>Cookies are <code>small text files</code> that are placed on your computer or mobile device when you visit our website. They are widely used to make websites work more efficiently and provide information to site owners.</p>
        
        <h2>How We Use Cookies</h2>
        <p>We use cookies for various purposes:</p>
        
        <h3>Essential Cookies</h3>
        <div style="background-color: #d4edda; border: 1px solid #c3e6cb; padding: 10px; border-radius: 5px; margin: 10px 0;">
          <p><strong>✓ Required for basic functionality</strong></p>
          <p>These cookies are necessary for the website to function and cannot be switched off in our systems.</p>
        </div>
        
        <h3>Performance Cookies</h3>
        <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; padding: 10px; border-radius: 5px; margin: 10px 0;">
          <p><strong>📊 Analytics and monitoring</strong></p>
          <p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site.</p>
        </div>
        
        <h3>Functional Cookies</h3>
        <div style="background-color: #d1ecf1; border: 1px solid #bee5eb; padding: 10px; border-radius: 5px; margin: 10px 0;">
          <p><strong>⚙️ Enhanced functionality</strong></p>
          <p>These cookies enable the website to provide enhanced functionality and personalization.</p>
        </div>
        
        <h3>Targeting Cookies</h3>
        <div style="background-color: #f8d7da; border: 1px solid #f5c6cb; padding: 10px; border-radius: 5px; margin: 10px 0;">
          <p><strong>🎯 Advertising and marketing</strong></p>
          <p>These cookies may be set through our site by our advertising partners to build a profile of your interests.</p>
        </div>
        
        <h2>Managing Your Cookie Preferences</h2>
        <p>You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.</p>
        
        <h3>Browser Settings</h3>
        <ul>
          <li><strong>Chrome:</strong> Settings → Privacy and security → Cookies and other site data</li>
          <li><strong>Firefox:</strong> Settings → Privacy & Security → Cookies and Site Data</li>
          <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
          <li><strong>Edge:</strong> Settings → Cookies and site permissions</li>
        </ul>
        
        <div style="background-color: #fff3cd; border: 1px solid #ffeaa7; padding: 15px; border-radius: 5px; margin: 15px 0;">
          <h4>⚠️ Important Note:</h4>
          <p>Please note that if you disable cookies, some features of our website may not function properly, and your user experience may be diminished.</p>
        </div>
        
        <h2>Third-Party Cookies</h2>
        <p>We also use third-party services that may set cookies on your device:</p>
        <dl>
          <dt><strong>Google Analytics</strong></dt>
          <dd>We use Google Analytics to analyze website traffic and user behavior. <a href="https://policies.google.com/privacy" target="_blank">Learn more</a></dd>
          
          <dt><strong>Social Media Plugins</strong></dt>
          <dd>Our website includes social media features that may set cookies to enable functionality and track usage.</dd>
          
          <dt><strong>Advertising Partners</strong></dt>
          <dd>We work with advertising partners who may use cookies to show you relevant ads on other websites.</dd>
        </dl>
        
        <h2>Updates to This Policy</h2>
        <p>We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated revision date.</p>
        
        <p><small>For questions about this Cookie Policy, please contact us at <a href="mailto:cookies@example.com">cookies@example.com</a></small></p>
      </div>
    `,
  },
];

export type TTermsAndConditionsParams = {
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
};

export type TParams = {
  params: TTermsAndConditionsParams;
  options?: {
    enabled?: boolean;
  };
};

export interface TermsAndConditions {
  title: string;
  termsAndConditions: string;
  id: number;
}

export const getTermsAndConditions = async ({
  params: { page, pageSize, startDate, endDate },
}: TParams): Promise<IPaginatedResponse<TermsAndConditions[]>> => {
  if (USE_MOCK) {
    // Return mock data using setTimeout to simulate network delay
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          message: "",
          page: 1,
          pageSize: 10,
          status: true,
          status_code: 200,
          totalCount: 100,
          totalPages: 5,
          data: mockTermsAndConditions,
        });
      }, 5000);
    });
  }

  let queryParams = `?Page=${page}&PageSize=${pageSize}`;
  if (startDate) queryParams += `&startDate=${startDate}`;
  if (endDate) queryParams += `&endDate=${endDate}`;

  const { data } = await getData(
    `${ajaxEndpoints.DB_TERMS_AND_CONDITIONS}${queryParams}`
  );

  return data;
};

export const useGetTermsAndConditions = ({ params, options }: TParams) => {
  return useQuery<IPaginatedResponse<TermsAndConditions[]>, Error>(
    ["termsAndConditions", { params, options }],
    () => getTermsAndConditions({ params, options }),
    {
      enabled: options?.enabled ?? true,
    }
  );
};
